import React from 'react'
import { CalendarTodayIcon, GuestIcon } from '@toasttab/buffet-pui-icons'
import { Experience } from '../../api/experiences/model'
import { useFormatCurrency } from '../../hooks/useFormatCurrency'
import { Ticket } from './icons/Ticket'
import { getExperiencePartySizeRange } from '../../utils/getExperiencePartySizeRange'
import { getFormattedDatesActive } from '../../utils/getFormattedDatesActive'
import { useIntlProps } from 'banquet-runtime-modules'
import { Formats } from '@toasttab/buffet-pui-date-utilities'
import { ViewExperienceLink } from './ViewExperienceLink'
import { getExperiencePaymentDetailLabel } from './utils'

export const ExperienceCardContent = ({
  experience
}: {
  experience: Experience
}) => {
  const { language: locale } = useIntlProps()
  const formatCurrency = useFormatCurrency()
  const partySizeRange = getExperiencePartySizeRange(experience)
  const formattedDateRange = getFormattedDatesActive(
    locale,
    experience,
    Formats.date.medium_without_year
  )

  const paymentDetailLabel = getExperiencePaymentDetailLabel(
    experience,
    formatCurrency
  )

  return (
    <div className='flex flex-col gap-2 w-full'>
      <div className='flex items-start justify-between gap-4'>
        {/* Name + Payment data */}
        <div>
          <div className='flex flex-col gap-1'>
            <div className='flex flex-col font-semibold type-large line-clamp-2'>
              {experience.name}
            </div>
            {experience.payment && (
              <div className='flex items-center'>
                <Ticket />
                <span className='pl-1 font-semibold type-subhead'>
                  From {paymentDetailLabel}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className='justify-self-end'>
          <ViewExperienceLink
            experience={experience}
            className='w-full sm:none'
          />
        </div>
      </div>
      <div className='flex flex-col gap-3'>
        {/* Dates + Party Size + Payment amount for prepayment*/}
        <div className='flex flex-col gap-1'>
          {(experience.datesActive.length > 0 ||
            experience.shifts.length > 0) && (
            <div>
              <CalendarTodayIcon size='xs' accessibility='decorative' />
              <span className='pl-1 font-semibold type-subhead'>
                {formattedDateRange}
              </span>
            </div>
          )}
          {experience.shifts.length > 0 && (
            <div className='flex flex-row items-center'>
              <GuestIcon size='xs' accessibility='decorative' />
              <span className='pl-1 font-semibold type-subhead'>
                Party size {partySizeRange}
              </span>
            </div>
          )}
        </div>
        {/* Description */}
        {experience.memo?.description && (
          <p className='text-secondary line-clamp-4 mt-2'>
            {experience.memo.description}
          </p>
        )}
      </div>
    </div>
  )
}
